import React from 'react';
import PropTypes from 'prop-types';
import TrackedField from '../common/TrackedField';

const ModalHistory = props => (
    <div className="modal modal-backdrop" data-backdrop="static" tabIndex="-1" role="dialog" style={{ display: props.visible ? 'block' : 'none' }}>
        <div className="modal-dialog" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={props.close}><span aria-hidden="true">&times;</span></button>
                    <h4 className="modal-title">Receipt History</h4>
                </div>
                <div className="modal-body">
                    { props.visible ? (
                        <TrackedField
                            objectName="Receipt__c"
                            salesforceId={props.id}
                            hashToken={props.token}
                            withTitle={false}
                        />
                    ) : null }
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-default" onClick={props.close}>Close</button>
                </div>
            </div>
        </div>
    </div>
);

ModalHistory.propTypes = {
    close: PropTypes.func.isRequired,
    visible: PropTypes.bool,
    id: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
};

ModalHistory.defaultProps = {
    visible: false,
};

export default ModalHistory;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Receipt/ModalHistory.js
// module id = 993
// module chunks = 0